// removed by extract-text-webpack-plugin
module.exports = {"Modal":"kt98bEAo4Fxz7nQm0jXKG","Header":"_1VEeX53uLQre5sA3XwT3Mk","Steps":"_17ahLEiHqNINtqtnsCgDv-","StepsContent":"Z9b3_CVYYfYWDx381phIB","Content":"_3aZAIssPl_zyoYQxwiBA6a","Intro":"_3AHG5RFy29861FwIXGyfYB","Outro":"_13opQq8JbS7znbhbgS1HUx","Question":"_2AwBnjB7bsgD0xuRZDitlM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/styles.css
// module id = 693
// module chunks = 0